import { firestore as db, functions } from '@jaymathew/ui-shared/apis/FirebaseUtilities/FirebaseConfig'
import { collection, DocumentData, getDocs, query, QueryDocumentSnapshot, startAfter, where } from 'firebase/firestore'
import { httpsCallable, HttpsCallableResult } from 'firebase/functions'
import { Company } from 'resources/types'
import { getSelectedCompanyId } from 'shared/functions/selectedCompanyAccess'


export interface GetCompaniesReturnType<T> {
	payload: T[],
	lastDocument?: QueryDocumentSnapshot<DocumentData>
}

export const getCompanies = async (companyIDs: string[], lastDocument?: QueryDocumentSnapshot<DocumentData>): Promise<{ payload: Company[], lastDocument?: QueryDocumentSnapshot<DocumentData> }> => {

	if (companyIDs.length === 0) {
		return {
			payload: [],
			lastDocument: undefined,
		}
	}

	const collectionRef = collection(db, 'companies')
	let companiesCollectionRef = query(collectionRef, where('id', 'in', companyIDs))

	if (lastDocument) {
		companiesCollectionRef = query(companiesCollectionRef, startAfter(lastDocument))
	}

	const companiesCollection = await getDocs(companiesCollectionRef)

	if (companiesCollection.empty) {

		return {
			payload: [],
			lastDocument: undefined,
		}
	}

	const companies: Company[] = companiesCollection.docs.map((doc) => doc.data() as Company)

	return {
		payload: companies,
		lastDocument: companiesCollection.docs[companiesCollection.docs.length - 1],
	}
}


export const editCompanyAccount = async ({ payload }: { payload: Partial<Company> }) => {
	const companyID = getSelectedCompanyId() ?? ''
	//create the Ref to the cloud callable function.
	const cloudfunction = httpsCallable(functions, 'firebasefuncUpdateCompany')

	//call the function with the parms
	const result: HttpsCallableResult = await cloudfunction({
		companyID,
		...payload,
	})

	//return what the cloud function returned
	return result
}
